module.exports = "pegasus_template/assets/themelp1/health/103.png";